import { Capacitor } from '@capacitor/core'
import { env } from '@/env'

declare global {
  interface Window {
    jlmDesktop?: { isDesktop: true; platform: string; version: string }
  }
}

/**
 * Replaces Quasar's `$q.platform`. Three shells share this bundle and they
 * differ in ways the UI genuinely cares about: how OAuth hands off, whether
 * routing can use the History API, and whether hover affordances exist.
 */

export const isDesktop = (): boolean =>
  env.buildTarget === 'electron' || (typeof window !== 'undefined' && !!window.jlmDesktop)

export const isNative = (): boolean => Capacitor.isNativePlatform()

export const nativePlatform = (): 'ios' | 'android' | 'web' =>
  Capacitor.getPlatform() as 'ios' | 'android' | 'web'

/**
 * True when the History API is usable. Electron loads the renderer over
 * file://, where pushState paths cannot be reloaded, so it gets hash routing.
 */
export const supportsHistoryRouting = (): boolean => env.buildTarget !== 'electron'

/** Coarse pointer — used to keep hover-only controls reachable by touch. */
export const isTouchPrimary = (): boolean =>
  typeof window !== 'undefined' && window.matchMedia?.('(pointer: coarse)').matches === true
